import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams ,ViewController} from 'ionic-angular';
import { Departamentos } from '../../models/Departamentos';

@IonicPage()
@Component({
  selector: 'page-departamentos-editar',
  templateUrl: 'departamentos-editar.html',
})
export class DepartamentosEditarPage {
  DepartamentosData:any[] = []
  Departamentos: Array<Departamentos> = []
  Departamento:Departamentos[] = []
  DepartamentosCopia:Departamentos[] = []
  fechaExpedicion:string =""
  fechaIngreso:string =""    
  tipoIdentificacion:string = ""
  constructor(public navParams: NavParams,
              public viewControllers:ViewController) {
    if(this.navParams.get('DepartamentosData')){
      let data = this.navParams.get('DepartamentosData')
    this.Departamentos = this.extender(this.Departamentos,{
        codigoDepartamento: data.codigoDepartamento,
        nombreDepartamento: data.nombreDepartamento,
        paisesId: data.paisesId,
        queHago: "A",
        departamentosId : data.departamentosId,
        nombreTabla: "departamentos",
        name: "dataDynamicCrud"
      })
    }
  }

  extender (obj, values) {
    const clone = Object.assign({}, obj)
    return Object.assign(clone, values)
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad DepartamentosDataElectronicosEditarPage');
  }

  dismiss(){
    this.viewControllers.dismiss();
  }

  submit(){
   this.viewControllers.dismiss(this.Departamentos);
  }  
}



// WEBPACK FOOTER //
// ./src/pages/departamentos-editar/departamentos-editar.ts